import { Plugin } from 'prosemirror-state';
import { DecorationSet, Decoration } from 'prosemirror-view';
import { annotationPluginKey, uiStatePluginKey } from './keys';
import { currentMark, currentMarkRange } from '../utils/selection';

export default (schema) => {
  return new Plugin({
    state: {
      init(config, instance) {
        return {
          decos: DecorationSet.empty,
          activeAnnotation: null,
          annotatableSelectionRange: { from: null, to: null },
          activeAnnotationRange: { from: null, to: null },
          highlightedText: null
        };
      },
      // Handles:
      // - setting range for annotatable selection
      // - creating decorations for temp annotations
      // - activating annotation on click
      apply(tr, annotationState, oldState, newState) {
        const meta = tr.getMeta(annotationPluginKey);

        const newTmpAnnotation = meta && meta.type === 'createTmpAnnotation';

        const hideCommentsClicked = document.getElementsByClassName('hide-comments').length;
        const annotationClicked =
          !hideCommentsClicked && tr.getMeta('pointer') && currentMark(tr.doc, tr.selection.from, schema.marks.annotation);

        const { from, to } = newState.selection;
        const selectionChanged = !oldState.selection.eq(newState.selection);
        const { historyMode } = uiStatePluginKey.getState(oldState);
        const selectionLargeEnough = Math.abs(from - to) > 2;
        const selectionContainsAnnotation = newState.doc.rangeHasMark(
          from,
          to,
          schema.marks.annotation
        );

        const newAnnotationState = { ...annotationState };

        if (selectionChanged) {
          newAnnotationState.activeAnnotationRange = { from: null, to: null };
          newAnnotationState.annotatableSelectionRange = { from: null, to: null };
        }

        if (
          selectionChanged &&
          !historyMode &&
          selectionLargeEnough &&
          !selectionContainsAnnotation
        ) {
          const selectedText = newState.doc.textBetween(from, to);

          newAnnotationState.highlightedText = selectedText;
          newAnnotationState.annotatableSelectionRange = { from, to };
        }

        if (!(newTmpAnnotation || annotationClicked)) {
          newAnnotationState.decos = DecorationSet.empty;
          newAnnotationState.activeAnnotation = null;
          return newAnnotationState;
        }

        if (annotationClicked) {
          newAnnotationState.activeAnnotation = annotationClicked.attrs.uuid;
          const range = currentMarkRange(
            tr.doc,
            tr.selection.from,
            newState,
            schema.marks.annotation
          );

          if (range) {
            newAnnotationState.decos = DecorationSet.create(tr.doc, [
              Decoration.inline(range.from, range.to, {
                class: 'activeAnnotation'
              })
            ]);

            newAnnotationState.activeAnnotationRange = { from: range.from, to: range.to };
          }

          return newAnnotationState;
        }

        if (newTmpAnnotation) {
          newAnnotationState.activeAnnotation = null;
          newAnnotationState.decos = DecorationSet.create(tr.doc, [
            Decoration.inline(oldState.selection.from, oldState.selection.to, {
              class: 'tmpAnnotation'
            })
          ]);
        }

        return newAnnotationState;
      }
    },
    key: annotationPluginKey,
    props: {
      decorations(state) {
        // @ts-ignore
        return this.getState(state).decos;
      }
    }
  });
};



// WEBPACK FOOTER //
// ./app/javascript/client/editor-core/plugins/AnnotationPlugin.js